export const LoginRedirect = async () => {
  function getURL(url) {
    if (url.includes("localhost")) {
      return "https://payments-api-uat.accorplus.com/v1/dev/login";
    } else if (url.includes("accorstaging")) {
      return "https://payments-api-uat.accorplus.com/v1/login";
    } else {
      return "https://payments-api.accorplus.com/v1/login";
    }
  }

  // function nonProdEnv(url) {
  //     return (url.includes('localhost') || url.includes('accorstaging'));
  // }
  // const isNonProd = nonProdEnv(window.location.origin);
  // let paymentsAPIUrl = isNonProd ? "https://payments-api-uat.accorplus.com/v1/login" : "https://payments-api.accorplus.com/v1/login";
  let paymentsAPIUrl = getURL(window.location.origin);
  console.log("paymentsAPIUrl", paymentsAPIUrl);

  try {
    console.log("Redirecting...");
    const response = await fetch(paymentsAPIUrl, {
      method: "GET",
    }).then((res) => res.json());

    const redirectURI = response.headers.Location;
    window.location.href = redirectURI;
  } catch (error) {
    console.error("Error during login redirect:", error);
  }
};
